import store from "@/store";
import {postalCodeHandlerFinancial} from "@/utils/financialBkoForm/postalCodeHandler";
import {PROFILES_ENUM, profilesMapping} from "@/enums/profiles/profiles";
import i18n from "@/i18n";
import router from "@/router";
import { useFinancialNationality, } from "@/enums/financials/financialNationality";

const COMPLEX_TABS = ["spreadsData", "insuranceData", "nominalInterestRateData"];
const SPREAD_FILTERS_MAPPER = {
    "company": {
        "0": "Todas as Empresas"
    },
    "brand": {
        "ALL": "Todas as Marcas"
    },
    "product": {
        '1': 'Crédito',
        '2': 'ALD',
        '3': 'Leasing',
        '4': 'Select (BMW)',
        '5': 'Crédito Oficinal',
        '6': 'Crédito Motas',
        '7': 'Crédito com Renda Balão',
        '8': 'Crédito com Carência',
        '9': 'Crédito com Renda Diferenciada',
        '10': 'Intersolução',
        '11': 'Refinanciamento do Valor Residual',
        '12': 'ALD C/ Manutenção',
        '13': 'Crédito C/ Manutenção e Ext. Garantia',
        '14': 'Leasing C/ Manutenção e Ext. Garantia',
        '15': 'Hyundai Open Drive',
        '16': 'Financiación',
        '17': 'Flex Finance',
        '18': 'Finance FIT',
        '19': 'Finance Fit - Subvencionado',
        '20': 'Crédito Clássico'
    },
    "clientType": {
        "5": "ALL",
        "1": "Particular",
        "2": "ENI",
        "3": "Empresa"
    },
    "dateStart": {
    },
};

export function getValueFormData(data, fieldKey) {
    let value = data ? data[fieldKey] : "";
    if (fieldKey === "ID_PROFILE") value = profilesMapping[value];
    if (fieldKey === "STATUS" || fieldKey === "status") value = value === "S" || !value ? 1 : 2;
    if (fieldKey === "GENDER") value = value === "M" || !value ? 1 : 2;

    if (fieldKey === "api" || fieldKey === "ftp"
        || fieldKey === "emailAlertNewProposal"
        || fieldKey === "emailWithDocumentation" || fieldKey === "emailWithXML") {
        value = value == true ? 1 : 2;
    }
    return value;
}

export async function spreadDataHandler(data, spreadDataParam) {
    const spreadsData = spreadDataParam ? spreadDataParam : data?.spreadData?.rates;
    const companies = data.companies;

    if (!spreadsData) {
        return;
    }

    const createUniqueArray = (data, key) => {
        const set = new Set();

        Object.entries(data).forEach(([itemKey]) => {
            const value = itemKey.split("||")[key];
            set.add(value);
        });

        return [...set].sort((a, b) => {
            // Try to parse as number, fallback to string comparison
            const numA = Number(a);
            const numB = Number(b);
            if (!isNaN(numA) && !isNaN(numB)) {
                return numA - numB;
            }
            // If values are dates, sort by date
            const dateA = new Date(a);
            const dateB = new Date(b);
            if (!isNaN(dateA) && !isNaN(dateB)) {
                return dateB - dateA;
            }
            // Otherwise, fallback to localeCompare for strings
            return a.localeCompare(b);
        });
    };

    const formatArray = (arr, mapperKey) => {
        if(mapperKey === 'company') {
            SPREAD_FILTERS_MAPPER[mapperKey] = Object.assign(SPREAD_FILTERS_MAPPER[mapperKey], companies);
        }

        if(mapperKey === 'product') {
            const productsUsed = data?.financialData?.products_used || [];
            const productsUsedObj = productsUsed.reduce((acc, curr) => {
                acc[curr.id] = curr.name;
                return acc;
            }, {});
            SPREAD_FILTERS_MAPPER[mapperKey] = Object.assign(SPREAD_FILTERS_MAPPER[mapperKey], productsUsedObj);
        }

        return [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...arr.map(item => ({
                value: item,
                text: SPREAD_FILTERS_MAPPER[mapperKey][item] ? SPREAD_FILTERS_MAPPER[mapperKey][item] : item, // Assuming your item names are keys for translation
            })),
        ];
    };

    // Create formatted arrays
    const formattedCompanyArray = formatArray(createUniqueArray(spreadsData, 0), 'company');
    const formattedBrandArray = formatArray(createUniqueArray(spreadsData, 1), 'brand');
    const formattedClientTypeArray = formatArray(createUniqueArray(spreadsData, 2), 'clientType');
    const formattedProductArray = formatArray(createUniqueArray(spreadsData, 3), 'product');
    const formattedDateStartArray = formatArray(createUniqueArray(spreadsData, 4), 'dateStart');

    // Commit to the store
    store.commit("FinancialsBkoFormModule/setSpreadsFilters", {key: 'companyArray', arr: formattedCompanyArray});
    store.commit("FinancialsBkoFormModule/setSpreadsFilters", {key: 'brandArray', arr: formattedBrandArray});
    store.commit("FinancialsBkoFormModule/setSpreadsFilters", {key: 'clientTypeArray', arr: formattedClientTypeArray});
    store.commit("FinancialsBkoFormModule/setSpreadsFilters", {key: 'productArray', arr: formattedProductArray});
    store.commit("FinancialsBkoFormModule/setSpreadsFilters", {key: 'dateStartArray', arr: formattedDateStartArray});

}

export const lockFinancialFields = (formObject, toEdit) => {

    if (!toEdit) {
        formObject?.tabs?.map((tab) => {
            tab.form.map((form) => form?.fields?.map((formFields) => {
                switch (tab.key) {
                    case 'spreadsData':
                        if (form.sectionId !== 1) formFields.editable = false;
                        if(formFields.key === 'addSpread') formFields.fieldShow = false;
                        break;
                    case 'insuranceData':
                        if (form.sectionId !== 1) formFields.editable = false;
                        break;
                    case 'nominalInterestRateData':
                        if (form.sectionId !== 1) formFields.editable = false;
                        break;
                    default:
                        formFields.editable = false;
                        break;
                }
            }));
            tab.btns[1] = {};
        });
    }

    return formObject;
};

function getFinacialDataByTabKey(data, tabKey) {
    let input;

    if (tabKey == 'generalData') {
        input = data?.generalData;
    }

    if (tabKey == 'financingData') {
        input = data?.financingData;
    }

    if (tabKey == 'insuranceData') {
        input = data?.insuranceData;
    }

    if (tabKey == 'spreadData') {
        input = data?.spreadData;
    }

    if (tabKey == 'financialData') {
        input = data?.financialData;
    }

    return input;
}

function setDefaultProperties(field) {
    //set default properties
    
    field.hasError = field.hasError || false;
    field.editable = field.editable || false;
    field.required = field.required || false;
    field.loading = field.loading || false;
    if(field?.key.startsWith('dateStart') && field?.type === 'date') {
        field.hasError = false;
    }
}

export async function setInsuranceDropdown(populateAction, { idFinancial, idInstance }) {
    const financial = await store.dispatch(populateAction.name, { idFinancial: idFinancial, idInstance: idInstance });
    const insurances = financial?.insuranceData.insurances_used;
    const insuranceDropdown = [
        {
            value: -1,
            text: i18n.t("dropdownSelection"),
            disabled: true,
        }
    ];

    Object.keys(insurances).forEach(key => {
        insuranceDropdown.push(
            {
                id: key,
                value: insurances[key].name,
                text: insurances[key].name
            }
        )
    })

    return insuranceDropdown;
}

export function financialDetailsMapperHandler(formObject, form, data, formKey, tabKey) {
    let input = getFinacialDataByTabKey(data, tabKey);
    const routeParams = router.currentRoute.params;
    const financeId = routeParams.id;
    const instanceId = routeParams.idInstance;

    //const ptFinancialMapper = financialNationalityMap.find((financialMapper) => financialMapper.nationality === "PT");
    //const isPTFinancial = ptFinancialMapper.financialIds.includes(Number(financeId));
    const isPTFinancial = useFinancialNationality("PT")?.includes(Number(financeId)) || false;
    const country = isPTFinancial ? 'PT' : 'ES';

    if(isPTFinancial && tabKey === 'spreadsData') {
        const spreadData = store.getters['FinancialsBkoFormModule/getSpreadData'];
        spreadDataHandler(data, spreadData);
    }

    if (COMPLEX_TABS.includes(tabKey)) {
        // if(isPTFinancial && tabKey === 'insuranceData') {
        //     const insuranceTab = formObject.tabs.find((f) => f?.key?.startsWith("insuranceData"));
        //     insuranceTab.form = [{
        //         "label": "",
        //         "sectionId": 1,
        //         "fields": [
        //             {
        //                 "label": "Financeira Portuguesa - Em desenvolvimento",
        //                 "type": "text-label",
        //                 "key": "disclaimer",
        //                 "fieldShow": true,
        //                 "colspan": 12,
        //                 "required": false,
        //                 "flexdir": "col",
        //                 "editable": true
        //             }
        //         ]
        //     }];
        // }
        form?.fields.map(async (field) => {
            if ((field.type === "dropdown" || field.type === "multi-select") && field.populateOptionsActions) {
                if (field.populateOptionsActions) {
                    field.populateOptionsActions?.map(async (populateAction) => {
                        switch (populateAction.type) {
                            case 'action':
                                await store.dispatch(populateAction.name);
                                break;
                            case 'companyByCountry':
                                await store.dispatch(populateAction.name, country);
                                break;
                            case 'productWithFinanceId':
                                field.options = await store.dispatch(populateAction.name, { financialId: financeId, idInstance: instanceId });
                                break;
                            case 'insuranceAction':
                                field.options = [];
                                field.options = await setInsuranceDropdown(populateAction, { idFinancial: financeId, idInstance: instanceId });
                                field.keyReRender++;
                                break;
                            case 'getter':
                                field.options = store.getters[populateAction.name];
                                field.keyReRender++;
                                break;
                            case 'getter-rate':
                                field.options = [
                                    {
                                        value: -1,
                                        text: i18n.t("dropdownSelection"),
                                        disabled: true,
                                    },
                                    {
                                        value: 0,
                                        text: i18n.t("Todas"),
                                    },
                                    ...store.getters[populateAction.name],
                                ]
                                field.keyReRender++;
                                break;
                            case 'getter-to-filter':
                                if(!isPTFinancial) {
                                    field.options = store.getters[populateAction.name];
                                }
                                
                                if(isPTFinancial) {
                                    /*const rateSalesmanData = store.getters['FinancialsBkoFormModule/getRatesSalesmanData'];
                                    const entityCompanies = Object.keys(rateSalesmanData);
                                    
                                    companyList = companyList?.filter(
                                        option => option.value === -1 
                                            || option.value == 0 || entityCompanies.some((item) => item.split('||')[0] == option.value)
                                    );*/
                                    field.options = store.getters[populateAction.name];
                                }
                                
                                field.keyReRender++;
                                break;
                            case 'getterWithKey':
                                field.options = store.getters[populateAction.name](populateAction.key);
                                break;
                        }

                        field.keyReRender++;
                    });
                }

                if(!isPTFinancial && tabKey === 'nominalInterestRateData' 
                    && field.key.startsWith('vehicleStatus')
                ) {
                    field.fieldShow = false;
                }
            }

            if((field.type === "seller-input") && tabKey === 'nominalInterestRateData') {
                field.country = country;
            }

            if((field.type === "nominal-rate") && tabKey === 'nominalInterestRateData' 
                && !isPTFinancial
            ) {
                field.fieldShow = true;
            }

            if(tabKey === 'insuranceData' && field?.key === 'editInsurancesTab') {
                const path = router?.history?.current?.path
                if(!path.includes('edit')) {
                    field.fieldLabel = 'Ver Seguros';
                }
            }

            if ((field.type === "text") && field.populateOptionsActions) {
                field.populateOptionsActions?.map(async (populateAction) => {
                    switch (populateAction.type) {
                        case 'openRateAction':
                            field.value = store.getters[populateAction.name];
                            break;
                    }

                    field.keyReRender++;
                });
            }

            if(!isPTFinancial && (field.type === "seller-input" || field.type === 'multi-select') && tabKey === 'nominalInterestRateData') {
                field.country = country;
                field.fieldShow = false;
            }

            if(!isPTFinancial && (field.type === "button-save" || field.key === 'productRate') && tabKey === 'nominalInterestRateData') {
                field.fieldShow = false;
            }

            if(isPTFinancial && field.key === 'dateStartArray' && 
                (tabKey === 'nominalInterestRateData' || tabKey === 'insuranceData')
            ) {
                field.fieldShow = false;
            }

            if (isPTFinancial && field.key === "entityCompany") {
                field.fieldShow = false;
            }

            //set default properties
            setDefaultProperties(field);

            if (field.type !== "neo-toggle") {
                field.keyReRender = 1;
            }
        });
    } else {
        form?.fields.map(async (field) => {
            if ((field.type === "dropdown" || field.type === "multi-select" || field.type === "multi-select-2") && field.populateOptionsActions) {

                if (field.populateOptionsActions) {
                    field.populateOptionsActions.map(async (populateAction) => {
                        if (populateAction.type === "action" && !field.key.startsWith('cpExt')) {
                            await store.dispatch(populateAction.name);
                        }

                        switch (populateAction.type) {
                            case 'getter':
                                field.options = store.getters[populateAction.name];
                                break;
                            case 'getterUsed':
                                field.value = store.getters[populateAction.name];
                                break;
                        }

                        if (populateAction.payload === "postalCode") {
                            const country = input?.nationality === 'ES' ? "ES" : "PT";
                            await postalCodeHandlerFinancial(form, input, country, populateAction);
                        }

                        if (field.key?.startsWith("nationality") || field.key?.startsWith("xmlVersion") 
                            || field.key?.startsWith("expensesFinanced") || field.key?.startsWith("taxFinanced")
                        ) {
                            let value = getValueFormData(input, field.key);
                            if(field.key?.startsWith("expensesFinanced") || field.key?.startsWith("taxFinanced")) {
                                value = data?.financialData?.[field.saveKey];
                            }

                            field.options = store.getters[populateAction.name];
                            field.options?.map((option) => {
                                option.selected = option?.value === value;
                            });

                            if(!(field.key?.startsWith("expensesFinanced") || field.key?.startsWith("taxFinanced"))) {
                                field.value = value;
                            }

                            store.commit("FinancialsBkoFormModule/setFieldAttribute", {
                                key: field?.key,
                                attribute: 'options',
                                value: field.options
                            });
                            
                            store.commit("FinancialsBkoFormModule/setFieldValue", {"key": field?.key, "value": value});
                            store.commit("FinancialsBkoFormModule/setIncrementField", {key: field?.key});
                        }

                        field.keyReRender++;
                    });
                }
            }

            if (field.type !== "text-label" && field.type !== 'multi-select' && field.type !== "dropdown" && field.type !== "neo-toggle") {
                if (field.key.startsWith("index")) {
                    input = getFinacialDataByTabKey(data, "financialData");
                }
                let value = getValueFormData(input, field.key);

                if (field.type === "text" && tabKey === 'generalData' && (field?.key === "technicalContactPhone" || field?.key === "technicalContactGsm"
                    || field?.key === "comercialContactPhone" || field?.key === "comercialContactGsm")
                ) {
                    const country = data?.generalData?.nationality === 'ES' ? "ES" : "PT";
                    field.prefixValue = country === "PT" ? "+351" : "+34";
                }

                if(field.key?.startsWith("legalizationExpenses") 
                    || field.key?.startsWith("extraExpensesForTAEG")
                    || field.key?.startsWith("recognitionCommittee") 
                    || field.key?.startsWith("reserveExtinctionCost")
                ) {
                    value = data?.financialData?.[field.saveKey];
                }

                if(field.key?.startsWith("dealerCommissionPercentNewCar") 
                    || field.key?.startsWith("dealerCommissionPercentUsedCar")
                ) {
                    const comDeaPct = data?.dealerCommissionData?.[field.saveKey] || 0;
                    value = comDeaPct?.toFixed(3);
                }

                field.value = value === '0' ? '' : value;
                field.keyReRender++;
            }

            if (field.type === "neo-toggle") {
                field.value = getValueFormData(input, field.key);
                field.keyReRender++;
            }

            if (field.key.startsWith("entityGroups") && tabKey === 'generalData') {
                field.value = getValueFormData(input, field.key) ? getValueFormData(input, field.key) : [];
                const idProfile = store.getters["AuthenticationModule/getIdProfile"];
                field.fieldShow = idProfile == PROFILES_ENUM.SUPER_ADMIN || false;
            }

            setDefaultProperties(field);

            if (field.type !== "neo-toggle") {
                field.keyReRender = 1;
            }
        });
    }


    return form;
}